import { ASSET_KIND } from './constants';

export const isAssetOfKind = (asset, kind) => asset.kind === kind;

export const isCoverImage = (asset) =>
  isAssetOfKind(asset, ASSET_KIND.IMAGE);
